import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.300',
    endColor: 'alpha.400',
    minW: 'full',
    h: '20',
    borderRadius: 'md',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    borderRadius: 'md',
    mb: '0',
    border: 'none',
    lineHeight: 'normal',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    _hover: {
      '&&': {
        _placeholder: {
          color: 'whiteAlpha.700',
        },
        border: 'none',
      },
      color: 'white',
    },
    _focus: {
      '&&': {
        _placeholder: {
          color: 'whiteAlpha.700',
        },
        border: 'none',
      },
      color: 'white',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'whiteAlpha.700',
      fontWeight: 'bold',
      fontSize: 'xs',
    },
    sx: {
      '&&': {
        bg: 'blackAlpha.300',
        color: 'white',
        _placeholder: {
          color: 'whiteAlpha.700',
        },
      },
    },
  },
  inputRightIcon: {
    color: 'beta.300',
    boxSize: '4',
    as: Search,
    sx: {},
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: {
    alignItems: 'center',
    gap: 2,
    flex: 1,
    textAlign: 'left',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
  accordionButtonIconSvg: {
    color: 'beta.300',
    fontSize: 'md',
    sx: {
      filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
    },
  },
  accordionButtonText: {
    fontSize: 'md',
    fontWeight: 'bold',
    color: 'white',
    fontFamily: 'accent',
    textTransform: 'uppercase',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'white',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'white',
    sx: {},
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
